export const ROUTES = {
  //LAYOUT
  LAYOUT: "/",
  FORGET_PASSWORD: "/ForgotPassword",
  DISCLAIMER: "/disclaimer",
  VERIFICATION_PAGE: "/verification",
  SIGNUP: "/Signup",
  LOGIN: "/login",
};
